import { Code2, Github, Linkedin, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-2">
              <Code2 className="h-8 w-8 text-indigo-400" />
              <span className="text-xl font-bold">Congnixs</span>
            </Link>
            <p className="text-gray-400">
              Building tomorrow's solutions with today's technology.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Github className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/services/web-development" className="hover:text-white transition-colors">Web Development</Link></li>
              <li><Link to="/services/mobile-development" className="hover:text-white transition-colors">Mobile Apps</Link></li>
              <li><Link to="/services/cloud-solutions" className="hover:text-white transition-colors">Cloud Solutions</Link></li>
              <li><Link to="/services/it-consulting" className="hover:text-white transition-colors">Consulting</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><a href="#careers" className="hover:text-white transition-colors">Careers</a></li>
              <li><a href="#blog" className="hover:text-white transition-colors">Blog</a></li>
              <li><a href="#contact" className="hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2 text-gray-400">
              <li>No. 52 K No-1095/704/648/7/1014/52</li>
              <li>Girinagar (Bangalore), Bangalore South-560085, Karnataka</li>
              <li>Karnataka - 560085</li>
              <li>contact@congnixs.com</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400 space-y-2">
          <p>© {new Date().getFullYear()} Congnixs. All rights reserved.</p>
          <p className="text-sm">Powered by Zyntheris Software Solutions India LLP</p>
        </div>
      </div>
    </footer>
  );
}
